import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  inject,
} from '@angular/core';

import { Observable } from 'rxjs';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { GroupedServices } from '@fcom/dapi';
import { ButtonSize, ButtonTheme, IconPosition } from '@fcom/ui-components';
import { Category } from '@fcom/dapi/api/models/category';
import { ConfigService } from '@fcom/core/services/config/config.service';

import { ExtendedService, ProductTierPrice } from '../../interfaces/ancillaries-interface';

@Component({
  selector: 'fin-ancillary-selection',
  styleUrls: ['./ancillary-selection.component.scss'],
  templateUrl: 'ancillary-selection.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AncillarySelectionComponent implements OnInit, OnChanges {
  private configService = inject(ConfigService);

  readonly ButtonSize = ButtonSize;
  readonly ButtonTheme = ButtonTheme;
  readonly IconPosition = IconPosition;
  readonly SvgLibraryIcon = SvgLibraryIcon;
  readonly Category = Category;

  @Input()
  showRemove = true;
  @Input()
  ancillaries: ExtendedService[] = [];
  @Input()
  groupedServices: GroupedServices[] = [];
  @Input()
  hideSelection = false;
  @Input()
  isHighlightedServicesAvailable = false;
  @Input()
  serviceToVariantTierPricesMap: Map<string, ProductTierPrice>;

  @Output()
  removeSelections: EventEmitter<Event> = new EventEmitter();

  showRemoveBasedOnAncillaries: boolean;
  filteredGroupedServices: GroupedServices[];
  isHighlightedServicesTest$: Observable<boolean>;
  isAncillaryHighlightedServicesEnabled = false;

  ngOnInit(): void {
    this.showRemoveBasedOnAncillaries = this.showRemoveButton();
    this.filteredGroupedServices = this.getFilteredGroupedServices();

    this.isAncillaryHighlightedServicesEnabled = this.configService.cfg.enableAncillaryHighlightedServices;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['showRemove']?.firstChange || !changes['ancillaries']?.firstChange) {
      this.showRemoveBasedOnAncillaries = this.showRemoveButton();
    }

    if (!changes['groupedServices']?.firstChange) {
      this.filteredGroupedServices = this.getFilteredGroupedServices();
    }
  }

  private getFilteredGroupedServices(): GroupedServices[] {
    return this.groupedServices.filter(({ key }) => key !== 'pendingPayment');
  }

  private showRemoveButton(): boolean {
    return (
      this.showRemove &&
      this.ancillaries.every(
        (ancillary) =>
          ancillary.paidQuantity === 0 || +ancillary.totalPrice?.amount === 0 || ancillary.isModifiable === true
      )
    );
  }
}
